// @ts-nocheck
import React from 'react';
import { ChevronDown, ChevronRight, Sparkles } from 'lucide-react';

const STEPS = [
  { id: 'intent', label: "Analyse de l'intention…" },
  { id: 'hyde', label: 'Génération de requêtes (HyDE)…' },
  { id: 'retrieve', label: 'Recherche dans la base (LanceDB)…' },
  { id: 'critique', label: 'Évaluation des sources…' },
];

/**
 * Panneau type « pensée de l’IA » : étapes synthétiques avant meta, puis détails retrieval.
 */
export default function ReasoningTrace({
  meta,
  phaseStep = 0,
  collapsed = false,
  onToggle,
  streamingStarted = false,
}) {
  return (
    <div className={`reasoning-trace ${collapsed ? 'reasoning-trace--collapsed' : ''}`}>
      <button
        type="button"
        className="reasoning-trace__header"
        onClick={onToggle}
        aria-expanded={!collapsed}
      >
        {collapsed ? <ChevronRight size={20} /> : <ChevronDown size={20} />}
        <Sparkles size={16} className="reasoning-trace__icon" />
        <span>Pensée de l’IA</span>
        {streamingStarted && collapsed && (
          <span className="reasoning-trace__badge">Réponse en cours…</span>
        )}
      </button>

      {!collapsed && (
        <div className="reasoning-trace__body">
          <ul className="reasoning-trace__steps">
            {STEPS.map((s, i) => {
              const done = meta ? true : i < phaseStep;
              const active = !meta && i === phaseStep % STEPS.length;
              return (
                <li
                  key={s.id}
                  className={`reasoning-trace__step ${active ? 'is-active' : ''} ${done ? 'is-done' : ''}`}
                >
                  {active && !meta && (
                    <span className="reasoning-trace__spinner" aria-hidden />
                  )}
                  <span>{s.label}</span>
                </li>
              );
            })}
          </ul>

          {meta && (
            <div className="reasoning-trace__meta">
              <div>
                <strong>Méthode</strong> : {meta.retrieval_method || '—'}
              </div>
              <div>
                <strong>Chunks utilisés</strong> : {meta.chunks_used ?? '—'}
              </div>
              {meta.hallucination_risk && (
                <div>
                  <strong>Risque</strong> : {meta.hallucination_risk}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
